<template>
  <b-modal
    ref="preGeracao"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho-pre-geracao'"
    :modal-class="'center-modal'"
    title="Pré - geração do contrato comercial"
    title-class="titulo-modal"
    @show="showPreGeracao"
    @hide="limparCampos"
  >
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')"
      class="aviso-amarelo"
    >
      Ação de preenchimento desses dados está com a pessoa (cliente)! <a
        style="color:blue"
        @click="abrirAlterarStatus()"
      >Clique aqui</a>, para você continuar o preenchimento!
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Em análise')"
      class="aviso-amarelo"
    >
      A ação da proposta está com você, confira os dados e envie o contrato para assinar!
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Aguardando assinatura')"
      class="aviso-amarelo"
    >
      O contrato está em tramitação de assinatura pela DocuSign, quando todos assinarem a proposta será finalizada.
    </div>
    <div
      v-if="valueInner.etiquetas.some(where => where.descricao === 'Contrato assinado')"
      class="aviso-amarelo"
    >
      Contrato assinado! Para fazer o download do contrato clique no botão de imprimir disponível na barra lateral da proposta.
    </div>

    <validation-observer ref="validacao">
      <transferencia-matriz-filial
        v-if="valueInner.tipoProposta === 'transferencia'"
        ref="transferencia"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        :desabilitar-campos="preGeracao.enviadoParaAnalise"
        :proposta-contrato="valueInner.contrato"
        :proposta-valor="valueInner.valorTotalPropostaAuditar"
        :proposta-template="valueInner.templateContrato"
        :proposta-id="valueInner.id"
        :pendente-analise="isPendenteAnalise"
        :habilitar-campo="isHabilitado"
        :dados-socio="!valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Aguardando envio de dados')"
        @contrato-alterado="contratoAlterado($event)"
        @editar-socio="socioEmAlteracao"
      />

      <constituicao-matriz
        v-else-if="valueInner.tipoProposta === 'constituicao'"
        ref="constituicao"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        :proposta-contrato="valueInner.contrato"
        :proposta-valor="valueInner.valorTotalPropostaAuditar"
        :proposta-template="valueInner.templateContrato"
        :proposta-id="valueInner.id"
        :habilitar-campo="isHabilitado"
        :pendente-analise="isPendenteAnalise"
        :dados-socio="!valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Aguardando envio de dados')"
        @contrato-alterado="contratoAlterado($event)"
        @editar-socio="socioEmAlteracao"
      />

    </validation-observer>
    <b-row class="mt-2">
      <b-col>
        <div style="display: flex;justify-content: flex-end;">
          <b-btn
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="desabilitarBotao"
            @click="salvarPreGeracao"
          >
            Salvar
          </b-btn>
          <b-btn
            v-if="getStatusProposta !== 9"
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="desabilitarBotaoAssinatura"
            @click="enviarAssinatura"
          >
            Enviar contrato para assinar
          </b-btn>
          <b-btn
            v-else-if="getStatusProposta === 9 && !socioEmEdicao"
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="desabilitarBotaoAssinatura"
            @click="enviarAlteracaoContrato"
          >
            Enviar alteração do contrato
          </b-btn>
          <b-btn
            v-else-if="getStatusProposta === 9 && socioEmEdicao"
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="desabilitarBotaoAssinatura"
            @click="atualizarPregeracaoEEnviarAlteracaoContrato"
          >
            Enviar alteração do contrato
          </b-btn>
          <b-btn
            variant="danger"
            size="sm"
            @click="cancelar"
          >
            Cancelar
          </b-btn>
        </div>
      </b-col>
    </b-row>
    <loading
      :is-loading="isLoading"
      :cancelar-upload="cancelarBusca"
    />
    <alterar-status
      ref="alterarStatus"
      :proposta-atual="valueInner"
    />
  </b-modal>
</template>

<style lang="scss">
.alteracao-tamanho-pre-geracao {
  width: 1000px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.titulo-modal {
  font-size: 19px;
}

.aviso-pre-geracao {
  text-align: left;
  font-size: 15.5px;
  background-color: rgb(231, 231, 231) !important;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: rgb(255, 0, 0);
  font-weight: bold;
  p{
    margin:0
  }
}

.aviso-amarelo {
  text-align: left;
  font-size: 15.5px;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 10px;

}
</style>

<script>
import { mapGetters, mapActions } from 'vuex'
import { generateCode } from '@core/utils/utils'
import { ValidationObserver } from 'vee-validate'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'
import docuSign from '@/shared/mixins/docu-sign/docu-sign'

export default {
  name: 'PreGeracaoContrato',
  components: {
    ValidationObserver,
    TransferenciaMatrizFilial: () => import('./components/shared/transferencia-matriz-e-filial-proposta/TransferenciaMatrizEFilialProposta.vue'),
    ConstituicaoMatriz: () => import('./components/shared/constituicao-matriz/ConstituicaoMatriz.vue'),
    AlterarStatus: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/alterar-status/AlterarStatus.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
  },
  props: {
    propostaAtual: {
      type: Object,
      default: () => {},
    },
    statusProposta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      preGeracao: {
        eTipoFaturamentoBoletos: null,
        contratoSubstituir: null,
        emailsBoletosNFs: [],
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          veioDoRFB: false,
          atualizarDados: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
      },
      valueInner: {},
      socioEmEdicao: false,
    }
  },
  computed: {
    ...mapGetters('proposta', ['rateioRow', 'existeMaisDeUmContratante', 'getStatusProposta']),
    isHabilitado() {
      return this.valueInner.selecaoPreenchimento === 'auditar' && this.valueInner.statusProposta !== 'aguardandoassinatura' && this.valueInner.statusProposta !== 'finalizada'
    },
    desabilitarBotao() {
      return this.getStatusProposta === 8 || this.valueInner.etiquetas.some(som => som.descricao === 'Contrato assinado' && som.etiquetaSistema === true)
    },
    desabilitarBotaoAssinatura() {
      return this.getStatusProposta === 8 || this.valueInner.etiquetas.some(som => som.descricao === 'Aguardando envio de dados' && som.etiquetaSistema === true)
    },
    isPendenteAnalise() {
      return this.valueInner.etiquetas.some(som => som.etiquetaSistema && som.descricao === 'Em análise')
    },
  },
  watch: {
    propostaAtual(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = { ...value }
        if (this.valueInner.id > 0 && (this.valueInner.etiquetas.some(where => where.descricao === 'Em análise') || this.valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados'))) {
          this.$refs.preGeracao.show()
        }
      }
    },
  },
  created() {
    this.valueInner = { ...this.propostaAtual }
  },
  methods: {
    ...mapActions('proposta', ['limparRateio']),
    contratoAlterado(value) {
      this.$set(this.valueInner, 'contrato', value)
    },
    showPreGeracao() {
      if ((this.valueInner.statusProposta === 'aprovada'
      || this.valueInner.statusProposta === 'aguardandoassinatura'
      || this.valueInner.statusProposta === 'finalizada') && this.valueInner.id > 0) {
        api.getPreGeracaoContrato(this.valueInner.id)
          .then(result => {
            this.preGeracao = result.data ? result.data : this.preGeracao
            this.preGeracao.contratoSubstituir = this.valueInner.contrato
            this.preGeracao.carregado = true

            if (this.valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')) {
              this.preGeracao.enviadoParaAnalise = true
            }
            const itemChecklist = this.valueInner.itemChecklistPropostas.find(find => find.tipoRegra === 'tags')
            if (itemChecklist && itemChecklist.listaRespostas && !result.data) {
              this.getEmpresas(itemChecklist)
            }
            if (this.valueInner.etiquetas.some(where => where.descricao === 'Aguardando envio de dados')) {
              this.preGeracao.enviadoParaAnalise = true
            }

            this.preGeracao.eTipoFaturamentoBoletos = (!result.data || result.data.eTipoFaturamentoBoletos === 0) ? null : result.data.eTipoFaturamentoBoletos
          }).finally(() => {
            this.isLoading = false
          })
      }
    },
    getEmpresas(itemChecklist) {
      // eslint-disable-next-line global-require
      const axios = require('axios')
      this.isLoading = true
      apiPreGeracao.getEmpresasPreGeracao(itemChecklist.listaRespostas, 0, axios.CancelToken)
        .then(payload => {
          this.isLoading = false
          const dados = payload.data
          this.preGeracao.empresas = dados.empresas
          if (!this.valueInner.filial) {
            this.preGeracao.socios = dados.socios
          }
          if (!this.preGeracao.socios || this.preGeracao.socios.length === 0) {
            this.adicionarSocio()
          }
          this.preGeracao.carregado = true
          this.preGeracao.realizadoBusca = true
        }).catch(err => {
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    cancelar() {
      this.$refs.preGeracao.hide()
    },
    adicionarSocio() {
      this.preGeracao.socios = [{
        nome: null,
        cpf: null,
        veioDoRFB: false,
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        atualizarDados: false,
        code: generateCode(),
      }]
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const ref = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia : this.$refs.constituicao
      const arquivo = ref.$refs.anexos.getArquivosAnexados()
      const fileCertificado = arquivo.certificado
      const fileContratual = arquivo.contratual
      const fileOutros = arquivo.outros
      if (fileCertificado) {
        const name = `certificado;${fileCertificado.name || fileCertificado.filename}`
        formData.append('files', fileCertificado.file, name)
      }
      if (fileContratual) {
        const name = `contratual;${fileContratual.name || fileContratual.filename}`
        formData.append('files', fileContratual.file, name)
      }
      if (fileOutros) {
        const name = `outros;${fileOutros.name || fileOutros.filename}`
        formData.append('files', fileOutros.file, name)
      }

      const arquivosSocio = ref.retornaTodosArquivos()
      for (let index = 0; index < arquivosSocio.length; index += 1) {
        const { file, nome } = arquivosSocio[index]
        formData.append('files', file, nome)
      }

      formData.append('body', JSON.stringify(body))

      return formData
    },
    hasEmailDuplicado(array) {
      const valuesSoFar = Object.create(null)
      const arr = array.filter(fil => fil.email && fil.email !== '')
      for (let i = 0; i < arr.length; i += 1) {
        const value = arr[i].email
        if (value in valuesSoFar) {
          return true
        }
        valuesSoFar[value] = true
      }
      return false
    },
    regrasSalvarPreGeracao(dados) {
      if (!dados.socios || dados.socios.some(socios => socios.nome === '' || !socios.nome)) {
        this.$erro('É obrigatório informar o nome dos sócios')
        return false
      } if (!dados.socios || dados.socios.some(socios => socios.inscricao === '' || !socios.inscricao)) {
        this.$erro('É obrigatório informar a inscrição federal dos sócios')
        return false
      } if (dados.anexosECertificado && dados.anexosECertificado.senhaIncorreta) {
        this.$erro('Informe a senha correta do certificado')
        return false
      } if (dados.anexosECertificado && dados.anexosECertificado.anexoVencido) {
        this.$erro('Não é permitido anexar certificado vencido!')
        return false
      } if (this.hasEmailDuplicado(dados.socios)) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
        return false
      }
      return true
    },
    salvarPreGeracao() {
      const atualizarDadosContemNulll = this.preGeracao.socios.some(socio => socio.atualizarDados === null && socio.socioJaExisteNoHub && !socio.veioDoHub)
      const emailDuplicado = this.hasEmailDuplicado(this.preGeracao.socios)
      if (!atualizarDadosContemNulll && !emailDuplicado) {
        const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
        const value = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
        if (this.regrasSalvarPreGeracao(dados)) {
          const formData = this.getFormDataBody(value)
          apiPreGeracao.updatePreGeracaoContrato(this.valueInner.id, formData)
            .then(() => {
              this.$sucesso('Dados salvos')
            })
            .catch(err => {
              this.$erroResponse(err.message || err.response.data.message)
              throw err
            })
        }
      } else if (atualizarDadosContemNulll) {
        this.$erro('Existe sócio já cadastrado no sistema e não foi informado o que o sistema deve fazer com os dados gerais no cadastro automático desse sócio! Verifique a informação.')
      } else if (emailDuplicado) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
      }
    },
    enviarAssinatura() {
      const atualizarDadosContemNulll = this.preGeracao.socios.some(socio => (socio.atualizarDados === undefined || socio.atualizarDados === null) && socio.usuarioJaExistenteNoHub && !socio.veioDoHub)
      const emailDuplicado = this.hasEmailDuplicado(this.preGeracao.socios)
      if ((!this.preGeracao.contratoSubstituir || this.preGeracao.contratoSubstituir === '') && !this.valueInner.templateContrato) {
        this.$erro('É obrigatório ter um contrato vinculado ou customizado no grupo "6 - Contrato comercial"! Verifique a informação.')
      } else if (atualizarDadosContemNulll) {
        this.$erro('Existe sócio já cadastrado no sistema e não foi informado o que o sistema deve fazer com os dados gerais no cadastro automático desse sócio! Verifique a informação.')
      } else if (emailDuplicado) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
      } else if (this.preGeracao.emailsBoletosNFs === undefined || this.preGeracao.emailsBoletosNFs.length === 0) {
        this.$erro('É obrigatório ter no mínimo um e-mail para envio de NFs e boletos.')
      } else {
        this.$refs.validacao.validate()
          .then(success => {
            if (success) {
              const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
              if (this.validacaoManual(dados)) {
                this.$confirmar('Deseja realmente enviar o contrato para assinar agora?', 'Ao confirmar essa ação o sistema notificará os sócios por email para assinar o contrato.', 'question', 'danger')
                  .then(result => {
                    if (result.value) {
                      this.isLoading = true
                      this.enviarContrato()
                    }
                  })
                  .catch(err => {
                    this.isLoading = false
                    this.$erroResponse(err)
                    throw err
                  })
              }
            } else {
              this.$erro('Preencha os campos corretamente')
            }
          })
      }
    },
    enviarContrato() {
      this.preGeracao.valorProposta = this.propostaAtual.valorTotalPropostaAuditar
      // if (this.getStatusProposta === 9 && this.socioEmEdicao) {
      //   this.salvarPreGeracao()
      // }
      api.substituirTagsContrato(this.preGeracao, this.valueInner.id, true)
        .then(payload => {
          this.valueInner.contrato = payload.data
          if (!this.valueInner.contrato || this.valueInner.contrato === '') {
            this.$erro('O texto do contrato não deve ser vazio!')
          } else if (this.getStatusProposta === 9) {
            docuSign.enviarContratoAtualizado(this.valueInner.id)
              .then(() => {
                this.$sucesso('Contrato enviado!')
                this.isLoading = false
                this.socioEmEdicao = false
              })
              .catch(err => {
                this.isLoading = false
                this.socioEmEdicao = false
                this.$erro(err.response.data.message || err.message)
                throw err
              })
          } else {
            const value = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
            const formData = this.getFormDataBody(value)
            apiPreGeracao.enviarContratoParaAssinatura(this.valueInner.id, formData)
              .then(() => {
                this.enviarAssinaturaEletronica()
              })
              .catch(err => {
                this.isLoading = false
                this.$erro(err.response.data.message || err.message)
                throw err
              })
          }
        })
        .catch(err => {
          this.isLoading = false
          this.$erro(err.response.data.message || err.message)
          throw err
        })
    },
    enviarAssinaturaEletronica() {
      docuSign.enviarAssinatura(this.valueInner.id)
        .then(cartao => {
          if (cartao.data) {
            this.$emit('atualiza-cartao-proposta', { colunaDe: 3, propostaCartao: cartao.data })
          }
          this.$sucesso('Contrato enviado!')
          this.isLoading = false
        })
        .catch(err => {
          this.$erro(err.response.data.message || err.message)
          throw err
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    limparCampos() {
      this.limparRateio()
      this.preGeracao = {
        contratoSubstituir: '',
        emailsBoletosNFs: [],
        realizadoBusca: true,
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
      }
    },
    abrirAlterarStatus() {
      this.$refs.preGeracao.hide()

      this.$emit('abrir-modal')
    },
    cancelarBusca() {
      this.isLoading = false
      api.cancelarBusca()
    },
    validacaoManual(dados) {
      if (!dados.socios || dados.socios.length === 0 || (dados.socios.length === 1 && dados.socios.some(som => !som.nome || som.nome === ''))) {
        this.$erro('Deve ter no mínimo um sócio adicionado!')
        return false
      }
      if (!dados.socios.some(some => some.responsavelRFB)) {
        this.$erro('Informe qual sócio é responsável perante a RFB para enviar os dados para análise!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && (!dados.anexosECertificado.tipoCertificado || dados.anexosECertificado.tipoCertificado === '0')) {
        this.$erro('Selecione um tipo de certificado!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.nomeArquivoCertificado || dados.anexosECertificado.nomeArquivoCertificado === '')) {
        this.$erro('Certificado é obrigatório!')
        return false
      }
      if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.senhaCertificado || dados.anexosECertificado.senhaCertificado === '')) {
        this.$erro('Preencha a senha')
        return false
      }
      if (dados.socios.some(som => !som.email || som.email === '')) {
        this.$erro('Insira um email valido')
        return false
      }
      if ((this.valueInner.tipoProposta === 'transferencia' || (this.valueInner.tipoProposta === 'constituicao' && this.valueInner.filial))
          && (!dados.anexosECertificado.nomeArquivoContratual || dados.anexosECertificado.nomeArquivoContratual === '')) {
        this.$erro('Arquivo contratual é obrigatório!')
        return false
      }
      if (dados.anexosECertificado.anexoVencido) {
        this.$erro('Não é permitido anexar certificado vencido!')
        return false
      }
      if (this.hasEmailDuplicado(dados.socios)) {
        this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
        return false
      }
      const linhasValidacao = this.rateioRow.filter(filter => filter.subTotal !== 0 && filter.subTotal !== null)
      if (this.existeMaisDeUmContratante && this.valueInner.tipoProposta === 'transferencia' && (this.valueInner.filial || (dados.eTipoFaturamentoBoletos === 1)) && (linhasValidacao.length === 0 || linhasValidacao.some(som => som.children.some(some => !some.subTotal || some.subTotal === 0)))) {
        this.$erro('É obrigatório realizar o rateio de valores para Omie! Verifique a informação.')
        return false
      }
      return true
    },
    enviarAlteracaoContrato() {
      this.$confirmar('Deseja realmente reenviar esse contrato para assinar agora?', 'Ao confirmar essa ação se o contrato não conter nenhuma assinatura na DocuSign, somente será substituído o PDF. Porém, se conter assinatura o sistema irá anular o contrato anterior e enviar um novo contrato!', 'question', 'danger')
        .then(result => {
          if (result.value) {
            this.isLoading = true
            docuSign.enviarContratoAtualizado(this.valueInner.id, true)
              .then(() => {
                this.$sucesso('Contrato enviado!')
              })
              .catch(err => {
                this.$erro(err.response.data.message || err.message)
                throw err
              })
              .finally(() => {
                this.isLoading = false
              })
          }
        })
    },
    socioEmAlteracao() {
      this.socioEmEdicao = true
    },
    atualizarPregeracaoEEnviarAlteracaoContrato() {
      this.$confirmar('Deseja realmente reenviar esse contrato para assinar agora?', 'Ao confirmar essa ação se o contrato não conter nenhuma assinatura na DocuSign, somente será substituído o PDF. Porém, se conter assinatura o sistema irá anular o contrato anterior e enviar um novo contrato!', 'question', 'danger')
        .then(result => {
          if (result.value) {
            this.isLoading = true
            const atualizarDadosContemNulll = this.preGeracao.socios.some(socio => socio.atualizarDados === null && socio.socioJaExisteNoHub && !socio.veioDoHub)
            const emailDuplicado = this.hasEmailDuplicado(this.preGeracao.socios)
            if (!atualizarDadosContemNulll && !emailDuplicado) {
              const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
              if (this.regrasSalvarPreGeracao(dados)) {
                const formData = this.getFormDataBody(dados)
                // chamada para atualizar checklist
                apiPreGeracao.updatePreGeracaoContrato(this.valueInner.id, formData)
                  .then(() => {
                    // chamada para substituir as tags
                    api.substituirTagsContrato(this.preGeracao, this.valueInner.id, true)
                      .then(payload => {
                        this.valueInner.contrato = payload.data
                        if (!this.valueInner.contrato || this.valueInner.contrato === '') {
                          this.$erro('O texto do contrato não deve ser vazio!')
                        } else if (this.getStatusProposta === 9 && this.socioEmEdicao) {
                          // chamada para enviar contrato
                          docuSign.enviarContratoAtualizado(this.valueInner.id, this.socioEmEdicao)
                            .then(() => {
                              this.$sucesso('Contrato enviado!')
                            })
                            .catch(err => {
                              this.$erro(err.response.data.message || err.message)
                              throw err
                            })
                            .finally(() => {
                              this.isLoading = false
                              this.socioEmEdicao = false
                            })
                        }
                      })
                      .catch(err => {
                        this.isLoading = false
                        this.$erro(err.response.data.message || err.message)
                        throw err
                      })
                  })
                  .catch(err => {
                    this.$erroResponse(err.message || err.response.data.message)
                    throw err
                  })
              }
            } else if (atualizarDadosContemNulll) {
              this.$erro('Existe sócio já cadastrado no sistema e não foi informado o que o sistema deve fazer com os dados gerais no cadastro automático desse sócio! Verifique a informação.')
            } else if (emailDuplicado) {
              this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
            }
          }
        })
    },
  },
}
</script>
